import React from "react";
export default function Home() {
  return <div style={{ padding: 32 }}>Welcome to TrakieBC!</div>;
}
